import { render, staticRenderFns } from "./IconDyslexic.vue?vue&type=template&id=fd7b773e&"
import script from "./IconDyslexic.vue?vue&type=script&lang=ts&"
export * from "./IconDyslexic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports